import React from 'react';
import { Redirect } from 'react-router-dom';

import moment from 'components/momentWithZone';
import passport from 'components/passportUtils';

export const isVisible = (rules, section) => {
	return rules.filter(rule => rule.section === section).length > 0
};

const filterRules = (props) => {
	const rules = props.configRules || [];
	return rules
		.filter(rule => rule.voyage === props.booking.EventId)
		.filter(rule => rule.showAlways === "1" || moment().isBetween(moment.utc(rule.showFrom), moment.utc(rule.hideAfter)))
		.filter(rule => {
			if(rule.personTypes === 'all'){
				return true;
			}
			else if(rule.personTypes === 'all except waitlist'){
				if(!props.isWaitList){
					return true;
				}
			}
			else if(props.isWaitList){
				if(rule.personTypes === 'waitlist'){
					return true;
				}
			}
			else{
				return (props.isStudent && rule.personTypes === 'students') ||
				(props.isFaculty && rule.personTypes === 'faculty') ||
				(props.isStaff && rule.personTypes === 'staff') ||
				(props.isLLL && rule.personTypes === 'life long learners') ||
				(props.isGapOrPost && rule.personTypes === 'gap/post students') ||
				(props.isStudent && !props.isGapOrPost && rule.personTypes === 'non-gap/post students');
			}

			return false;
		});
};

export const isEnabled = (props, section) => {
	const rules = filterRules(props);
	return rules.filter(rule => rule.section === section && (rule.enableAlways === "1" || moment().isBetween(moment.utc(rule.enableFrom), moment.utc(rule.disableAfter)))).length > 0
}

export const redirectIfHidden = (props, section) => {
	if (props.bookingLoaded && filterRules(props).filter(rule => rule.section === section).length === 0) {
		return <Redirect to="/portal" />
	}
}

export const menuItems = (props) => {
	const filteredRules = filterRules(props);
	return [
/*
		{
			titleText: 'Port Safety Information',
			key: 'Safety',
			children: [
				{label: 'Medical Capability Reports', visible: isVisible(filteredRules, 'safety/medicalcapabilityreports')}
			],
		},
*/
		{
			titleText: 'Personal Details',
			key: 'Personal',
			children: [
				{label: 'Basic Information', visible: isVisible(filteredRules, 'personal/basic')},
				{label: 'Emergency Contacts', visible: isVisible(filteredRules, 'personal/emergency')},
				{label: 'SSN', visible: isVisible(filteredRules, 'personal/SSN')},
				{label: 'Gender Identity', visible: isVisible(filteredRules, 'personal/gender')},
			]
		},
/*
		{
			titleText: 'Admissions',
			key: 'Admissions',
			children: [
				{
					label: 'Academic Action Plan', 
					visible: isVisible(filteredRules, 'admissions/academic') && (props.academicActionStatus !== "W")
				},
				{
					label: 'Signatory Statement', 
					visible: isVisible(filteredRules, 'admissions/signatory') && 
					((props.statusesLoaded && props.statuses.SRI_SIGN_ALCOHOL !== null && props.statuses.SRI_SIGN_ALCOHOL !== 'D') || (props.statusesLoaded && props.statuses.SRI_SIGN_FIRE !== null && props.statuses.SRI_SIGN_FIRE !== 'D') || (props.statusesLoaded && props.statuses.SRI_SIGN_PGRAD !== null && props.statuses.SRI_SIGN_PGRAD !== 'D') || (props.statusesLoaded && props.statuses.SRI_SIGN_DRUG !== null && props.statuses.SRI_SIGN_DRUG !== 'D')),
				}   
			],
			status: () => ((props.academicActionStatus === "R" || props.academicActionStatus === "I" || props.academicActionStatus === "" ) || ((props.statusesLoaded && props.statuses.SRI_SIGN_ALCOHOL === "E") || (props.statusesLoaded && props.statuses.SRI_SIGN_FIRE === "E") || (props.statusesLoaded && props.statuses.SRI_SIGN_PGRAD === "E") || (props.statusesLoaded && props.statuses.SRI_SIGN_DRUG === "E")) ? 'required' : 'done')
		},
*/
		{
			titleText: 'Travel Requirements',
			key: 'Travel',
			children: [
				{label: 'Passport Details', visible: isVisible(filteredRules, 'travel/passport')},
				{label: 'Visa Pre-Embarkation Form', visible: isVisible(filteredRules, 'travel/visaform')},
				{
					label: 'Visa Instructions and Documents',
					visible: isVisible(filteredRules, 'travel/visadocs'),
					blockIf: () => {
						if ((props.remarksLoaded && !props.remarks.find(remark => remark.Code === 'VISAPRE' && remark.rmkNumericCheck1 === '1')) || !passport.isComplete(passport.parseFromFolio(props.folio)))
							return 'You must provide your passport details and agree to the Pre-Embarkation Form Terms before moving on to this section'
						return false;
					}
				},
				{
					label: 'Visa Status',
					visible: isVisible(filteredRules, 'travel/visastatus'),
					blockIf: () => {
						if ((props.remarksLoaded && !props.remarks.find(remark => remark.Code === 'VISAPRE' && remark.rmkNumericCheck1 === '1')) || !passport.isComplete(passport.parseFromFolio(props.folio)))
							return 'You must provide your passport details and agree to the Pre-Embarkation Form Terms before moving on to this section'
						return false;
					}
				},
			]
		},
/*
		{
			titleText: 'Embarkation and Shuttles',
			key: 'Embarkation',
			status: () => (!props.bookingLoaded) ? '' : (props.bookingHasShuttle)? 'done': 'required',
			visible: isVisible(filteredRules, 'shuttles')
		},
*/
		{
			//commenting out Global studies stuff beacuse they want to get rid of it for students
			titleText: 'Field Programs',
			key: 'Field',
			children: [
				{label: 'Registered', visible: isVisible(filteredRules, 'field/registered')},
				// {
				// 	label: 'Global Studies Credit Eligible Field Programs',
				// 	requiredIf: () => props.GSCneeded && !props.GSCused,
				// 	blockIf: () => {
				// 		if (props.GSCused === true) return 'You have already used your Global Studies Credit';
				// 		return false;
				// 	},
				// 	visible: isVisible(filteredRules, 'field/GSCE')
				// },
				{
					label: 'Browse All',
					// blockIf: () => {
					// 	if (props.GSCneeded === true && props.GSCused === false)
					// 		return 'You cannot book other programs until you have used your Global Studies Credit';
					// 	return false;
					// },
					visible: isVisible(filteredRules, 'field/browse')
				},{
					label: 'Checkout',
					visible: isVisible(filteredRules, 'field/checkout')
				}
			],
			//status: () => (!props.bookingLoaded) ? '' : (props.GSCneeded && !props.GSCused)? 'required' : 'done',
		},
		{
			titleText: () => (props.isStudent) ? 'Payments and Financial Aid' : (!props.isStudent) ? 'Payments' : 'Payments',
			key: 'Financial',
			children: [
				{
					label: 'Program Fee Payment Status',
					requiredIf: () => props.transactionsLoaded && props.tuitionChargeTotal > props.tuitionCreditTotal,
					visible: isVisible(filteredRules, 'financial/programfeepayment')
				},
				{
					label: 'Field Payment Status',
					requiredIf: () => props.transactionsLoaded && props.fieldChargeTotal > props.fieldCreditTotal,
					visible: isVisible(filteredRules, 'financial/fieldpayment')
				},
				{
					label: 'Financial Aid',
					visible: isVisible(filteredRules, 'financial/financialaid')
				},
				{
					label: 'Insurance Opt-out',
					requiredIf: () => props.transactionsLoaded && props.insuranceChargeTotal > props.insuranceCreditTotal,
					visible: isVisible(filteredRules, 'financial/insurance'),
				}
			],
			status: () => (props.transactionsLoaded && (props.fieldChargeTotal > props.fieldCreditTotal || props.tuitionChargeTotal > props.tuitionCreditTotal || props.insuranceChargeTotal > props.insuranceCreditTotal))? 'required': ''
		},
/*
		{
			titleText: 'Academic Information',
			key: 'Academic',
			children: [
				{label: 'Basic Information', visible: isVisible(filteredRules, 'academic/basic')},
				{label: 'CSU EID', visible: isVisible(filteredRules, 'academic/EID')},
				{label: 'Updated Transcript Status', visible: isVisible(filteredRules, 'academic/transcriptstatus')},
				{label: 'Transcript Address', visible: isVisible(filteredRules, 'academic/transcriptaddress')}
			]
		},
*/

		{
			titleText: 'Health and Medical',
			key: 'Health',
			children: [
				/* {label: 'Medical History Form', visible: isVisible(filteredRules, 'health/medicalhistory')}, 
				{label: 'Vaccinations', visible: isVisible(filteredRules, 'health/vaccinations')},*/
				{label: 'Allergies', visible: isVisible(filteredRules, 'health/allergies')},
				{label: 'Dietary Restrictions', visible: isVisible(filteredRules, 'health/dietary')}/*,
				{label: 'Special Accomodations', visible: isVisible(filteredRules, 'health/special')},
				{label: 'Health Insurance Information', visible: isVisible(filteredRules, 'health/info')}*/
			]
		},

		{
			titleText: 'Online Agreements',
			key: 'Agreements',
			status: () =>{ 
				if(!props.statusesLoaded) return '';
				if(props.isStudent && props.statuses.SRI_AGREE_TANDC &&
					props.statuses.SRI_AGREE_COFC &&
					props.statuses.SRI_AGREE_GR &&
					props.statuses.SRI_AGREE_CSU_TRAN &&
					props.statuses.SRI_AGREE_FERPA) {
						return 'done'
					}
				if(!props.isStudent && props.statuses.SRI_AGREE_TANDC &&
					props.statuses.SRI_AGREE_COFC &&
					props.statuses.SRI_AGREE_GR) {
						return 'done'
					}
					return 'required';
			},
			visible: isVisible(filteredRules, 'agreements')
			
		},
/*
		{
			titleText: 'Cabin Information',
			key: 'Cabin',
			children: [
				{label: 'Cabin Type Preferences', visible: isVisible(filteredRules, 'cabin/type')},
				{label: 'Gender Inclusive Housing Options', visible: isVisible(filteredRules, 'cabin/gender')},
				{label: 'Roommate Requests', visible: isVisible(filteredRules, 'cabin/roommates')},
			]
		}
*/
	];
};



// WEBPACK FOOTER //
// ./src/containers/Portal/menuItems.js